export default {
  BASE_URL: 'mm/',
  api: [
    {
      name: 'getProdStaticData',
      method: 'POST',
      desc: '统计各状态下的商品数量',
      path: 'prodStattic/getProdStaticData'
    },
    {
      name: 'getProdsSalesTableData',
      method: 'POST',
      desc: '商品销售的列表',
      path: 'prodStattic/getProdsSalesTableData'
    },
    {
      name: 'getProdStaticChartData',
      method: 'POST',
      desc: '商品统计的图',
      path: 'prodStattic/getProdStaticChartData'
    },
    {
      name: 'getProdsSalesTableDataExcel',
      method: 'POST',
      desc: '导出表格',
      path: 'prodStattic/getProdsSalesTableDataExcel'
    },
    {
      name: 'getProdsTableData',
      method: 'POST',
      desc: '商品弹出数据',
      path: 'prodStattic/getProdsTableData'
    },
    {
      name: 'getProdsTableDataExcel',
      method: 'POST',
      desc: '商品弹出导出数据',
      path: 'prodStattic/getProdsTableDataExcel'
    },
    {
      name: 'getOrgData',
      method: 'GET',
      desc: '企业/店铺名称获取',
      path: 'prodStattic/getOrgData'
    },
    {
      name: 'getShopStaticData',
      method: 'POST',
      desc: '店铺统计首页信息',
      path: 'shopStattic/getShopStaticData'
    },
    {
      name: 'getShopTableData',
      method: 'POST',
      desc: '店铺弹出信息',
      path: 'shopStattic/getShopTableData'
    },
    {
      name: 'getShopTableDataExcel',
      method: 'POST',
      desc: '弹出店铺信息导出数据',
      path: 'shopStattic/getShopTableDataExcel'
    },
    {
      name: 'getShopActivityData',
      method: 'POST',
      desc: '活跃买家',
      path: 'shopStattic/getShopActivityData'
    },
    {
      name: 'getShopActivityDataExcel',
      method: 'POST',
      desc: '活跃买家导出数据',
      path: 'shopStattic/getShopActivityDataExcel'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/sa/productSta.js